import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL: string) => {
  return {
    getListConfiguration: (idList: number) =>
      `${baseURL}/api/list/${idList}/configuration`,
    importClients: (idList: number) =>
      `${baseURL}/api/list/${idList}/import/clients`,
  }
})(process.env.BEFATTUREINCLOUD_URL as string)

export const beFattureinCloudApiGetListConfiguration = async (
  idList: number,
): Promise<ListConfiguration | null> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.getListConfiguration(idList),
    headers: { 'Content-Type': 'application/json' },
  }).then((res) => res.data)
}

export const beFattureinCloudApiImportClients = async (
  idList: number,
): Promise<ImportResult> => {
  return await apiWrapper({
    method: 'put',
    url: endpoints.importClients(idList),
    headers: { 'Content-Type': 'application/json' },
  }).then((res) => res.data)
}

export interface ListConfiguration {
  Status: FicConnectionStatus
  Configuration: ConfigurationDetails
}

export interface Connection {
  Id: number
  AccountEmail: string
  Status: FicConnectionStatus
}

export interface Configuration {
  IdList: number
  CompanyId: number
}

export interface ConfigurationDetails extends Configuration {
  Id: number
  IdConnection: number
  CompanyName: string
  Date: string
}

export type FicConnectionStatus = 'CONNECTED' | 'DISCONNECTED'

export interface ImportResult {
  Status: FicConnectionStatus
  FileName: string
}
